import { api } from './api.config'
import request from '@/utils/request'
export default {
  ukeyBox: {
    // 是否插盘
    getValidDevice (data) {
      return request({
        url: api.ukeyBox.getValidDevice,
        method: 'get',
        data
      })
    },
    sendCheckCode (data) {
      return request({
        url: api.ukeyBox.sendCheckCode,
        method: 'get',
        data,
        xToken: false
      })
    },
    useAccountLogin (data) {
      return request({
        url: api.ukeyBox.useAccountLogin,
        method: 'post',
        data,
        xToken: false
      })
    },
    // 新老用户
    getUserExist (data) {
      return request({
        url: api.ukeyBox.getUserExist,
        method: 'get',
        data
      })
    },
    // 新增用户
    addUser (data) {
      return request({
        url: api.ukeyBox.addUser,
        method: 'post',
        data
      })
    },
    // 是否有权限操作盒子
    getValidPerm (data) {
      return request({
        url: api.ukeyBox.getValidPerm,
        method: 'post',
        data
      })
    },
    // 绑定或更新绑定
    setBoxBind (data) {
      return request({
        url: api.ukeyBox.setBoxBind,
        method: 'post',
        data
      })
    },
    // 解除绑定
    setBindRemove (data) {
      return request({
        url: api.ukeyBox.setBindRemove,
        method: 'get',
        data
      })
    },
    // 查询盘信息
    getBoxInfo (data) {
      return request({
        url: api.ukeyBox.getBoxInfo,
        method: 'get',
        data
      })
    }
  }
}
